import React from 'react';
import { TableRow, Table, TableHead, TableCell, TableBody, styled, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { CustomerResolutionMetrics } from 'src/pages/FeatureAnalysis/AccuracyAnalysis';
import { paths } from 'src/frontend-common/components/Router';
import { Link } from 'react-router-dom';

const CustomerMetricsTable: React.FC<{ items: CustomerResolutionMetrics[] }> = ({ items }) => {
  const headers = ['Customer Id', 'Score', 'Risk count', 'Trust count', ''];
  const theme = useTheme();

  return (
    <Table>
      <TableHead>
        <TableRow>
          {headers.map((header) => (
            <TableCell key={header}>{header}</TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>
        {items.map((item) => (
          <TableRow key={`${item.customer_id}-${item.resolution_id}-${item.score}`} hover>
            <TableCellMinWidth>{item.customer_id}</TableCellMinWidth>
            <TableCellMinWidth>{item.score}</TableCellMinWidth>
            <TableCellMinWidth>{item.risk_count}</TableCellMinWidth>
            <TableCellMinWidth>{item.trust_count}</TableCellMinWidth>
            <TableCell style={{ width: 50 }}>
              <Link to={`${paths.customerDetailPage.prePath}/${item.resolution_id}`} target="_blank" rel="noopener noreferrer">
                <SearchIcon style={{ color: theme.palette.text.primary }} />
              </Link>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default CustomerMetricsTable;

const TableCellMinWidth = styled(TableCell)({
  minWidth: 135,
});
